
import m1 from "assets/images/users/1.jpg";
import m2 from "assets/images/users/2.jpg";
import m3 from "assets/images/users/3.jpg";
import m4 from "assets/images/users/4.jpg";
import m5 from "assets/images/users/5.jpg";
import m6 from "assets/images/users/6.jpg";
import m7 from "assets/images/users/7.jpg";
import m8 from "assets/images/users/8.jpg";
import m9 from "assets/images/users/9.jpg";
import fm1 from "assets/images/users/01.jpg";
import fm2 from "assets/images/users/02.jpg";
import fm3 from "assets/images/users/03.jpg";
import fm5 from "assets/images/users/05.jpg";
import fm6 from "assets/images/users/06.jpg";
import fm7 from "assets/images/users/07.jpg";
import fm8 from "assets/images/users/08.jpg";
import fm9 from "assets/images/users/09.jpg";


export const MitigateTimeSheetRecords = [
    {
        title: "Enhance Our Supply Chain",
        fly: "FLY-1",
        color: "#3CCB7F",
        progress: 80,
        taskStarDate: "4/1/2023",
        taskEndDate: "30/5/2023",
        icon: "icon-target",
        data: [
            {
                title: "Identify potential disru...",
                fly: "FLY-10",
                status: "Done",
                taskStarDate: "8/2/2023",
                taskEndDate: "14/3/2023",
                user: {
                    imageUrl: m9,
                },
            },
            {
                title: "Develop contingency pl...",
                fly: "FLY-13",
                status: "Done",
                taskStarDate: "4/1/2023",
                taskEndDate: "14/3/2023",
                user: {
                    imageUrl: fm1,
                },
            },
            {
                title: "Build relationships wit...",
                fly: "FLY-11",
                status: "Done",
                taskStarDate: "15/3/2023",
                taskEndDate: "28/4/2023",
                user: {
                    imageUrl: m9,
                },
            },
            {
                title: "Diversify supply chain",
                fly: "FLY-12",
                status: "New",
                taskStarDate: "30/4/2023",
                taskEndDate: "30/5/2023",
                user: {
                    imageUrl: m2,
                },
            },
        ],
    },
    {
        title: "2023 Financial Review Audit",
        fly: "FLY-1",
        color: "#875BF7",
        progress: 60,
        taskStarDate: "4/1/2023",
        taskEndDate: "14/3/2023",
        icon: "icon-shield",
        data: [
            {
                title: "Setup dev and ...",
                fly: "FLY-10",
                status: "Done",
                taskStarDate: "24/1/2023",
                taskEndDate: "20/2/2023",
                user: {
                    imageUrl: m2,
                },
            },
            {
                title: "As a user I can ...",
                fly: "FLY-13",
                status: "Done",
                taskStarDate: "20/2/2023",
                taskEndDate: "14/3/2023",
                user: {
                    imageUrl: fm2,
                },
            },
            {
                title: "Setup dev and ...",
                fly: "FLY-11",
                status: "Done",
                taskStarDate: "20/2/2023",
                taskEndDate: "14/3/2023",
                user: {
                    imageUrl: fm6,
                },
            }
        ],
    },
    {
        title: "2023 Financial Review Audit",
        fly: "FLY-1",
        color: "#22CCEE",
        progress: 70,
        taskStarDate: "24/3/2023",
        taskEndDate: "14/8/2023",
        icon: "icon-sliders",
        data: [
            {
                title: "Identify potential disru...",
                fly: "FLY-10",
                status: "Done",
                taskStarDate: "1/6/2023",
                taskEndDate: "19/8/2023",
                user: {
                    imageUrl: m9,
                },
            },
            {
                title: "Develop contingency pl...",
                fly: "FLY-13",
                status: "Done",
                taskStarDate: "24/3/2023",
                taskEndDate: "14/6/2023",
                user: {
                    imageUrl: fm1,
                },
            },
            {
                title: "Build relationships wit...",
                fly: "FLY-11",
                status: "Done",
                taskStarDate: "15/4/2023",
                taskEndDate: "28/7/2023",
                user: {
                    imageUrl: m9,
                },
            },
        ],
    },
    {
        title: "Assessment Name 1",
        fly: "FLY-1",
        color: "#FAC515",
        progress: 70,
        taskStarDate: "1/7/2023",
        taskEndDate: "1/10/2023",
        icon: "icon-bar-chart",
        data: [
            {
                title: "Identify potential disru...",
                fly: "FLY-10",
                status: "Done",
                taskStarDate: "1/7/2023",
                taskEndDate: "15/8/2023",
                user: {
                    imageUrl: m9,
                },
            },
            {
                title: "Develop contingency pl...",
                fly: "FLY-13",
                status: "Done",
                taskStarDate: "15/8/2023",
                taskEndDate: "1/10/2023",
                user: {
                    imageUrl: fm1,
                },
            },
        ],
    },
    {
        title: "Audit Name 1",
        fly: "FLY-1",
        color: "#D444F1",
        progress: 90,
        taskStarDate: "1/7/2023",
        taskEndDate: "15/12/2023",
        icon: "icon-zap",
        data: [
            {
                title: "Identify potential disru...",
                fly: "FLY-10",
                status: "Done",
                taskStarDate: "1/7/2023",
                taskEndDate: "30/8/2023",
                user: {
                    imageUrl: m6,
                },
            },
            {
                title: "Develop contingency pl...",
                fly: "FLY-13",
                status: "Done",
                taskStarDate: "1/9/2023",
                taskEndDate: "30/10/2023",
                user: {
                    imageUrl: fm8,
                },
            },
            {
                title: "Develop contingency pl...",
                fly: "FLY-13",
                status: "Done",
                taskStarDate: "1/11/2023",
                taskEndDate: "15/12/2023",
                user: {
                    imageUrl: m9,
                },
            },
        ],
    },
    {
        title: "Audit Name 2",
        fly: "FLY-1",
        color: "#528BFF",
        progress: 80,
        taskStarDate: "1/4/2023",
        taskEndDate: "15/8/2023",
        icon: "icon-zap",
        data: [
            {
                title: "Identify potential disru...",
                fly: "FLY-10",
                status: "Done",
                taskStarDate: "1/4/2023",
                taskEndDate: "30/5/2023",
                user: {
                    imageUrl: m3,
                },
            },
            {
                title: "Develop contingency pl...",
                fly: "FLY-13",
                status: "Done",
                taskStarDate: "1/6/2023",
                taskEndDate: "30/6/2023",
                user: {
                    imageUrl: fm2,
                },
            },
            {
                title: "Develop contingency pl...",
                fly: "FLY-13",
                status: "New",
                taskStarDate: "1/7/2023",
                taskEndDate: "15/8/2023",
                user: {
                    imageUrl: m7,
                },
            },
        ],
    },
    {
        title: "Strategic Workshop",
        fly: "FLY-1",
        color: "#F38744",
        progress: 70,
        taskStarDate: "1/5/2023",
        taskEndDate: "22/9/2023",
        icon: "icon-zap",
        data: [
            {
                title: "Identify potential disru...",
                fly: "FLY-10",
                status: "Done",
                taskStarDate: "1/5/2023",
                taskEndDate: "30/5/2023",
                user: {
                    imageUrl: m9,
                },
            },
            {
                title: "Develop contingency pl...",
                fly: "FLY-13",
                status: "Done",
                taskStarDate: "1/6/2023",
                taskEndDate: "30/6/2023",
                user: {
                    imageUrl: m2,
                },
            },
            {
                title: "Develop contingency pl...",
                fly: "FLY-13",
                status: "New",
                taskStarDate: "1/7/2023",
                taskEndDate: "22/9/2023",
                user: {
                    imageUrl: m4,
                },
            },
        ],
    },
    {
        title: "Strategic Workshop",
        fly: "FLY-1",
        color: "#7839EE",
        progress: 70,
        taskStarDate: "1/7/2023",
        taskEndDate: "24/12/2023",
        icon: "icon-zap",
        data: [
            {
                title: "Identify potential disru...",
                fly: "FLY-10",
                status: "Done",
                taskStarDate: "1/7/2023",
                taskEndDate: "30/8/2023",
                user: {
                    imageUrl: m9,
                },
            },
            {
                title: "Develop contingency pl...",
                fly: "FLY-13",
                status: "Done",
                taskStarDate: "30/8/2023",
                taskEndDate: "30/10/2023",
                user: {
                    imageUrl: fm5,
                },
            },
            {
                title: "Develop contingency pl...",
                fly: "FLY-13",
                status: "New",
                taskStarDate: "30/10/2023",
                taskEndDate: "24/12/2023",
                user: {
                    imageUrl: m7,
                },
            },
        ],
    },
];